import React, { FunctionComponent } from "react";
import { Table } from "evergreen-ui";
import { AbstractTableBodyCellRenderer } from "./AbstractTableBodyCellRenderer";
import { TableBodyCellRendererInput } from "../input";
import { FloatingMenuButton, FloatingMenuButtonPopoverItems } from "../../../FloatingMenuButton";
import { TableInputCell } from "../../view/TableInputCell";
import { resolveValidators } from "../../validation/resolveValidators";

export class TablePopoverCellRenderer<T> extends AbstractTableBodyCellRenderer<T> {
    protected readonly popoverMenuItems: FloatingMenuButtonPopoverItems[];
    protected readonly readOnly: boolean;

    constructor(
        input: TableBodyCellRendererInput<T>,
        popoverMenuItems: FloatingMenuButtonPopoverItems[],
        readOnly: boolean = false,
    ) {
        super(input);
        this.popoverMenuItems = popoverMenuItems;
        this.readOnly = readOnly;
    }

    protected getMemoizedComponent(): FunctionComponent {
        const {columnConfig, cellValue, onCellChanged, id} = this.input;
        const {textAlign} = columnConfig;
        const popoverMenuItems = this.popoverMenuItems;

        let cellComponent: JSX.Element;
        if (this.readOnly) {
            const textProps = textAlign ? { style: { textAlign } } : undefined;
            cellComponent = (
                <Table.TextCell className={"jc-body-cell read-only"} textProps={textProps}>
                    {cellValue}
                </Table.TextCell>
            );
        } else {
            const validators = resolveValidators(columnConfig.cellType, columnConfig.validation);
            cellComponent = (
                <TableInputCell
                    columnConfig={columnConfig}
                    id={id}
                    cellValue={cellValue}
                    onCellChanged={onCellChanged}
                    inputType={"text"}
                    validators={validators}
                />
            );
        }

        return React.memo(() => (
            <FloatingMenuButton height={"100%"} width={"100%"} menuItems={popoverMenuItems}>
                {cellComponent}
            </FloatingMenuButton>
        ));
    }
}
